import {reset} from "redux-form";

const clearFiles= () => async (dispatch) => {
  dispatch(reset('signature_form'));
};
export default clearFiles;
